<app-table
    tableKey="dashboardServiceAnnouncement"
    [gridData]="store.data.getServiceAnnouncements()"
    [hideCheckboxes]="true"
    [columns]="columns()"
    [translatePrefix]="prefix"
    [showSearch]="false"
    [showColumnVisiblity]="false"
    [showExport]="false"
    [showClearFilter]="false"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getServiceAnnouncements"
    [refreshCallbackFragment]="getServiceAnnouncementFrag"
    [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
    (detailCallback)="detail($event)"
>
</app-table>
